// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import Messages from "./messages";
import { API_URL } from "config";
import { useAuthContext } from "hooks/useAuthContext";
import { toast } from "sonner";
import { useEffect, useState } from "react";
// import ViewDocument from "mycomponents/Supervisor/supervisorDashboard/viewDocument";

function Dashboard() {
  const { user } = useAuthContext();
  const [supervisedStudents, setSupervisedStudents] = useState([]);
  const [availability, setAvailability] = useState(false);

  useEffect(() => {
    const fetchSupervisorStudents = async () => {
      try {
        const response = await fetch(
          `${API_URL}/supervisors/getSupervisedStudents/${user.email}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch supervised students.");
        }

        // Ensure valid JSON response
        let students = [];
        try {
          students = await response.json();
        } catch (jsonError) {
          throw new Error("Invalid JSON response from server.");
        }

        // Ensure students is an array before setting state
        if (Array.isArray(students)) {
          setSupervisedStudents(students);
        } else {
          throw new Error("Unexpected response structure from server.");
        }
      } catch (error) {
        console.error("Error fetching supervised students:", error.message);
        setSupervisedStudents([]);
      }
    };

    const fetchAvailability = async () => {
      try {
        const response = await fetch(
          `${API_URL}/availability/getindividualavailability/${user.email}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        const avail = await response.json();

        if (response.ok) {
          setAvailability(avail.available);
        } else {
          setAvailability(false);
        }
      } catch (error) {
        console.log(error);
        setAvailability(false);
      }
    };
    fetchSupervisorStudents();
    fetchAvailability();
  }, [user]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Supervised Students"
                count={supervisedStudents.length}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="calendar"
                title="Availability"
                count={availability ? "🟢 available" : "🔴 Not available"}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={3}>
          <Messages />
        </MDBox>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
